export default __webpack_public_path__ + "static/media/04.d62fcddf.jpg";